import React, { PureComponent } from 'react';
import {
    Nav, NavItem, NavLink,
  } from 'reactstrap';
import classnames from 'classnames';


import uuid from 'uuid'
import { Query } from 'react-apollo'
import { GetTrainingByUser } from '../../../queries/training'
import { signout } from '../../../redux/actions/userActions'
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import TrainingTable from './TrainingTable'

class TrainingCard extends PureComponent {

    state = {
        activeSubModule:{}
    }

    signoutUser () {
        this.props.signout();
      }

    componentDidMount(){
        const activeSubModules = this.props.subModules.filter(subModule => subModule.isActive === true)
        this.setState({activeSubModule:{
            subModuleName: activeSubModules[0].name,
            displayName: activeSubModules[0].displayName,
            subModuleIndex: 0
        }})
    }

    toggleUserComplianceTabs(activeSubModuleName,tab,displayName){
        if (this.state.activeSubModule.subModuleIndex !== tab) {
          this.setState({
            activeSubModule:{
                subModuleIndex:tab,
                subModuleName: activeSubModuleName,
                displayName: displayName
            }
          });
        }
      }

    render(){
        const activeSubModules = this.props.subModules.filter(subModule => subModule.isActive === true)
        return(
        <div>
                <Nav tabs>
                {activeSubModules.map((activeSubModule,index)=>{
                    return(<NavItem
                        key={uuid()}>
                        <NavLink
                            key={uuid()}
                            className={`pointer-element 
                            ${classnames({ active: index === this.state.activeSubModule.subModuleIndex })}`}
                            onClick={() => {
                            this.toggleUserComplianceTabs(activeSubModule.name, index, activeSubModule.displayName);
                            }}
                        >
                            {activeSubModule.displayName}
                        </NavLink>
                    </NavItem>)
                })}
            </Nav>
            <Query
                query={GetTrainingByUser()}
                fetchPolicy={'cache-and-network'}
                variables={{ input: this.state.activeSubModule.subModuleName }}
                onError={(e) => {
                if (e.networkError) {
                    if (e.networkError['statusCode'] === 401) {
                    this.signoutUser()
                    }
                } else {
                    console.log(e.message)
                    this.signoutUser()
                }
                }}
                onCompleted={(data) => {
                }}>
                {({ loading, error, data }) => {
                if (loading) return (<div style={{ textAlign: 'center', margin: '20px' }}>Loading...</div>)
                if (error) { console.log(`ERROR > ${error.message}`); return null }
                return (<TrainingTable trainingStats={data.getTrainingByUser} subModule={this.state.activeSubModule.displayName} />)
                }}
            </Query>
            {/*<div style={{overflowY: 'auto', maxHeight: '290px'}}>
                { this.state.trainingStats.length == 0 ? <div style={{ textAlign: 'center', margin: '20px' }}>Loading...</div> :
                <Table className='table--bordered table-hover' responsive striped>
                <thead>
                    <tr>
                    <th>Name</th>
                    <th>Security</th>
                    <th>HIPAA</th>
                    <th>This Month's</th>
                    <th>Score</th>
                    </tr>
                </thead>
                <tbody>
                {this.state.trainingStats.map((userStat, i) => {
                    return<tr key={i}>
                    <td>{userStat.name}</td>
                    <td>
                        <Badge
                        color={
                            userStat.securityQuizCompleted ? 'success' : 'danger'   
                        }>{userStat.securityQuizCompleted ? 'Yes' : 'No'}</Badge></td>
                    <td><Badge
                        color={
                            userStat.hipaaQuizCompleted ? 'success' : 'danger'   
                        }>{userStat.hipaaQuizCompleted ? 'Yes' : 'No'}</Badge></td>
                    <td><Badge
                        color={
                            userStat.completedMonthlyQuizzes.includes(moment().format("MMMM-YYYY")) ? 'success' : 'danger'   
                        }>{userStat.completedMonthlyQuizzes.includes(moment().format("MMMM-YYYY")) ? 'Yes' : 'No'}</Badge></td>
                    <td>{(userStat.securityQuizScore + userStat.hipaaQuizScore + userStat.totalMonthlyQuizScore)}</td>
                    </tr>
                })}
                </tbody>
                </Table>}
            </div>*/}
        </div>)
    }
}

export default connect(null, { signout })(withApollo(TrainingCard))


// WEBPACK FOOTER //
// ./src/components/compliance/components/TrainingCard.js